const ZUSTAND_STORE_KEY = "rapid-workspace-store";

/**
 * One-time migration helper for moving data out of the old Zustand persist
 * structure (`rapid-workspace-store`) into a standalone localStorage key.
 *
 * Reads `state[stateKey]` from the old store and writes it to `newKey`
 * if `newKey` doesn't already exist.
 *
 * Call at module scope so it runs once on import:
 * ```ts
 * migrateFromZustandStore("rapid-current-workspace", "currentWorkspace");
 * ```
 */
export function migrateFromZustandStore(newKey: string, stateKey: string): void {
    if (localStorage.getItem(newKey)) return;
    try {
        const raw = localStorage.getItem(ZUSTAND_STORE_KEY);
        if (!raw) return;
        const value = JSON.parse(raw)?.state?.[stateKey];
        if (value && (typeof value !== "object" || Object.keys(value).length > 0)) {
            localStorage.setItem(newKey, JSON.stringify(value));
        }
    } catch {
        // ignore — migration is best-effort
    }
}
